import React from 'react';

import { ComponentIconProps } from '../types';

const NotificationErrorIcon: React.FC<ComponentIconProps> = ({
  size = 24,
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <path d="M12 2L2 12L12 22L22 12L12 2ZM3.41 12L12 3.41L20.59 12L12 20.59L3.41 12ZM11 15C11 15.5523 11.4477 16 12 16C12.5523 16 13 15.5523 13 15C13 14.4477 12.5523 14 12 14C11.4477 14 11 14.4477 11 15ZM12.4859 12.8536C12.3862 12.9459 12.2559 12.9981 12.12 13H11.88C11.7441 12.9981 11.6138 12.9459 11.5141 12.8536C11.4143 12.7613 11.3523 12.6353 11.34 12.5L11 8C11 7.73478 11.1054 7.48043 11.2929 7.29289C11.4804 7.10536 11.7348 7 12 7C12.2652 7 12.5196 7.10536 12.7071 7.29289C12.8946 7.48043 13 7.73478 13 8L12.66 12.5C12.6477 12.6353 12.5857 12.7613 12.4859 12.8536Z" />
  </svg>
);

export default NotificationErrorIcon;
